import { render, staticRenderFns } from "./linkIntegrationLink.vue?vue&type=template&id=30646e84&scoped=true&"
import script from "./linkIntegrationLink.vue?vue&type=script&lang=js&"
export * from "./linkIntegrationLink.vue?vue&type=script&lang=js&"
import style0 from "./linkIntegrationLink.vue?vue&type=style&index=0&id=30646e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30646e84",
  null
  
)

export default component.exports